import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    token: window.sessionStorage.getItem("token"),
    role: window.sessionStorage.getItem("userRole"),
    // education-role  遴选-教育局角色  expert-role     遴选-专家角色  school-role     遴选-学校角色
    user: JSON.parse(window.sessionStorage.getItem("userInfo")),
    items:window.sessionStorage.getItem("items"),
    region: Number(process.env.VUE_APP_PROJECT_TYPE) //   吕梁: 1  |  临汾: 2  |  长治: 3
  },
  mutations: {
    updateUser(state, user) {
      state.user = user;
    },
    updateItems(state,items){
    	state.items = items;
    },
    updateToken(state, token) {
      state.token = token; 
    },
    updateRole(state, role) {
      state.role = role;
    },
  },
  actions: {},
  modules: {},
});
